module.exports = __webpack_public_path__ + "static/media/crown_golden.4c3a7090.png";